import { Link } from '@umijs/max';
import React from 'react';

type MenuItemProps = {
  children: any;
  path: string;
  target?: string;
};

const MenuItem: React.FC<MenuItemProps> = ({ path, children, target }) => {

  // !NOTE 扩展，可以让指定 tab 跳转至新浏览器 tab 窗口
  // 可以结合 tabList 缓存，来指导当前用户是否需要新窗口打开
  return (
    <Link to={path || '/'} target={target}>
      {children}
    </Link>
  );
};

export default MenuItem;
